const orderMqInformationLink = () => {
  const menus = document.querySelectorAll(
    '.header__inline-menu > .list-menu, .menu-drawer__navigation > .menu-drawer__menu'
  );

  menus.forEach((menu) => {
    const items = [...menu.children];
    const label = (item) => {
      const control = item.querySelector(':scope > a, :scope > details > summary');
      return control?.textContent.replace(/\s+/g, ' ').trim().toLowerCase() || '';
    };
    const information = items.find((item) => label(item) === 'information');
    const about = items.find((item) => ['om oss', 'about us'].includes(label(item)));

    if (information && about && information.nextElementSibling !== about) {
      menu.insertBefore(information, about);
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', orderMqInformationLink);
} else {
  orderMqInformationLink();
}
